import { useTranslation } from 'react-i18next'

import { Box, Divider, Paper, Stack, Typography } from '@mui/material'

import PageContainer from '@/components/ui/containers/PageContainer'

import CreatePolicyForm from './containers/CreatePolicyForm'

export function CreatePolicyPage() {
  const { t } = useTranslation()
  return (
    <PageContainer>
      <Paper>
        <Stack direction="row" alignItems="center" justifyContent="space-between" p={3}>
          <Stack spacing={1} sx={{ flex: 1 }}>
            <Typography variant="h2" component="div" noWrap sx={{ fontSize: { sm: '20px', lg: '24px' }, lineHeight: '28px', fontWeight: 700 }}>
              {t('page.createPolicy.title')}
            </Typography>
          </Stack>
        </Stack>
        <Divider />
        <Box p={3}>
          <CreatePolicyForm />
        </Box>
      </Paper>
    </PageContainer>
  )
}

export default CreatePolicyPage
